import api from "@/plugins/api";
import { isTaxReceiptEmailContextKey, isTaxReceiptEmailDonationTypeFilter, isTaxReceiptEmailDonorTypeFilter, } from "../../domain/entities/taxReceiptEmailContexts";
// Same BFF controller as the settings row (`OrganisationTaxReceiptSettingsController`), OPDON upstream.
const ENDPOINT = "/organisations/settings/tax-receipts/email-contexts";
const OPTIONS = { unwrapEnvelope: true };
function mapRule(dto) {
    if (!isTaxReceiptEmailDonorTypeFilter(dto.donorTypeFilter)) {
        throw new Error(`Unknown tax-receipt email donor filter "${dto.donorTypeFilter}".`);
    }
    if (!isTaxReceiptEmailDonationTypeFilter(dto.donationTypeFilter)) {
        throw new Error(`Unknown tax-receipt email donation filter "${dto.donationTypeFilter}".`);
    }
    return {
        donorTypeFilter: dto.donorTypeFilter,
        donationTypeFilter: dto.donationTypeFilter,
        templateId: dto.templateId,
    };
}
function mapContext(dto) {
    if (!isTaxReceiptEmailContextKey(dto.context)) {
        throw new Error(`Unknown tax-receipt email context "${dto.context}".`);
    }
    return {
        context: dto.context,
        defaultTemplateId: dto.defaultTemplateId ?? null,
        subject: dto.subject ?? "",
        // OPDON projects OrderedRules, so this sort only pins the contract: the list order is the priority.
        rules: [...(dto.rules ?? [])].sort((a, b) => a.priority - b.priority).map(mapRule),
        updatedAt: dto.updatedAt ?? null,
    };
}
export async function getTaxReceiptEmailContexts() {
    const response = await api.get(ENDPOINT, OPTIONS);
    return {
        UnitSend: mapContext(response.data.unitSend),
        AnnualCampaign: mapContext(response.data.annualCampaign),
    };
}
export async function updateTaxReceiptEmailContext(context, payload) {
    const response = await api.put(`${ENDPOINT}/${context}`, payload, OPTIONS);
    return mapContext(response.data);
}
